import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ApiResultModel, getAllJobSites } from "@WhiteCap/Store/Service/GetAllJobSitesService";

export interface GetAlljobSitesApiParameter extends ApiParameter {
    customerId?: string;
    page: number;
    pageSize: number;
    filter?: string;
    onError?: (message: string) => void;
}
type HandlerType = CustomApiHandler<GetAlljobSitesApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/BeginLoadAllJobSites",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const { page, pageSize, filter, customerId } = props.apiParameter;
    const result = await getAllJobSites(page, pageSize, customerId, filter);
    if (result.successful && result.result) {
        props.apiResult = result.result;
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/LoadAllJobSitesError",
            error: result.errorMessage,
        });
        return false;
    }
};

export const DispatchCompleteLoadAllJobSites: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/CompleteLoadAllJobSites",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadAllJobSites];

const loadAllJobSites = createHandlerChainRunner(chain, "LoadAllJobSites");
export default loadAllJobSites;
